import { useEffect } from 'react';

const DESKTOP_MIN_WIDTH = 1024;
const STICKY_GAP_PX = 20;
const STICKY_TOP_VAR = '--portfolio-map-sticky-top';

const getStickyTop = () => {
  const nav = document.querySelector('.site-menu-navigation');
  if (nav) {
    const navTop = parseFloat(window.getComputedStyle(nav).top) || 0;
    return nav.offsetHeight + navTop + STICKY_GAP_PX;
  }
  const fallback =
    document.querySelector('.site-menu') || document.querySelector('header');
  return (fallback ? fallback.offsetHeight : 0) + STICKY_GAP_PX;
};

export const useStickyMap = ({ sectionRef }) => {
  useEffect(() => {
    const update = () => {
      const section = sectionRef.current;
      if (!section || window.innerWidth < DESKTOP_MIN_WIDTH) return;
      section.style.setProperty(STICKY_TOP_VAR, `${getStickyTop()}px`);
    };

    window.addEventListener('resize', update, { passive: true });
    update();

    return () => window.removeEventListener('resize', update);
  }, [sectionRef]);
};
